<script>
import { customIcons } from '../plugins/mapSettings';

export default {
  name: 'googleGeoJson',
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    geoJson: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.geoJson) {
      this.map.data.addGeoJson(this.geoJson, { idPropertyName: 'storeid' });
      //
      this.map.data.setStyle(feature => {
        const cat = feature.getProperty('category');
        const icons = customIcons[cat] || {};
        let imageSize = new this.google.maps.Size(32, 44);
        if (cat === 'error') {
          imageSize = new this.google.maps.Size(64, 64);
        }
        return {
          icon: {
            url: icons.icon,
            scaledSize: imageSize,
          },
        };
      });
      // eslint-disable-next-line no-unused-vars
      const infoWindow = new this.google.maps.InfoWindow();
      this.map.data.addListener('click', event => {
        const name = event.feature.getProperty('name');
        const nameHTML = `<h2>${name}</h2>`;
        const description = event.feature.getProperty('description');
        const descHTML = `<p>${description}</p>`;
        const hours = event.feature.getProperty('hours');
        const hoursHTML = `<p><b>Nyitvatartás:</b><br>${hours}</p>`;
        const phone = event.feature.getProperty('phone');
        const phoneHTML = `<p><b>Telefonszám:</b><br>${phone}</p>`;
        const address = event.feature.getProperty('address');
        const addressHTML = `<p><b>Cím:</b><br>${address}</p>`;
        const position = event.feature.getGeometry().get();
        const contentStartHTML = '<div style="max-width: 300px;">';
        const contentEndHTML = '</div>';
        let content = '';
        content = contentStartHTML + nameHTML + descHTML + hoursHTML + addressHTML;
        if (phone !== null) {
          content += phoneHTML + contentEndHTML;
        } else {
          content += contentEndHTML;
        }
        infoWindow.setContent(content);
        infoWindow.setPosition(position);
        infoWindow.setOptions({ pixelOffset: new this.google.maps.Size(0, -30) });
        infoWindow.open(this.map);
        // this.map.setZoom(this.map.zoom + 1);
        this.map.setCenter(event.feature.getGeometry().get());
      });
    }
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
  render() {
    return null;
  },
};
</script>

<style scoped>

</style>
